import { Box, Divider } from '@mui/material';
import { forwardRef } from 'react';
import { MAXIMUM_COLUMNS_MOBILE, useCreditCardCompareColumnContext } from './ColumnContext';
import { AnnualFee } from './DetailSections/AnnualFee';
import { BonusOffer } from './DetailSections/BonusOffer';
import { Cons } from './DetailSections/Cons';
import { GreatFor } from './DetailSections/GreatFor';
import { IntroAPR } from './DetailSections/IntroAPR';
import { OngoingAPR } from './DetailSections/OngoingAPR';
import { Pros } from './DetailSections/Pros';
import { RewardsRate } from './DetailSections/RewardsRate';
import { ProductCard } from './ProductCardWithStickyHeader/ProductCard';
import { StickyHeader } from './ProductCardWithStickyHeader/StickyHeader';
import { RecommendedCreditScore } from './RecommendedCreditScore';

export const ComparisonColumn = forwardRef<HTMLDivElement, unknown>((_, ref) => {
  const { index } = useCreditCardCompareColumnContext();

  return (
    <>
      <StickyHeader />
      <Box
        position={{ md: 'relative', xs: 'inherit' }}
        flexDirection="column"
        display={{ md: 'flex', xs: index > MAXIMUM_COLUMNS_MOBILE - 1 ? 'none' : 'contents' }}
      >
        <Box
          position={{ md: 'inherit', xs: 'relative' }}
          flexDirection="column"
          display={{ md: 'contents', xs: 'flex' }}
          flex={1}
        >
          <Box
            {...(index === 0 && { className: 'first-column-header' })}
            sx={{
              position: 'absolute',
              inset: 0,
              pointerEvents: 'none',
            }}
          />
          <ProductCard innerRef={ref} />
        </Box>
        <Divider sx={{ borderColor: 'neutral.lighter', mx: 3 }} />
        <RecommendedCreditScore />
      </Box>
      <GreatFor />
      <AnnualFee />
      <BonusOffer />
      <RewardsRate />
      <IntroAPR />
      <OngoingAPR />
      <Pros />
      <Cons />
    </>
  );
});
